<template>
  <FeedbackStep :title="title" :number="number">
    <template v-slot:content>
      <div class="feedback-form">
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q2Rate1"
            type="radio"
            name="q2Rate"
            value="1 - źle"
            v-model.trim="form.answer_q2"
            @input="delayTouch($v.form.answer_q2)"
          />
          <label for="q2Rate1" class="form__label">1 - źle</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q2Rate2"
            type="radio"
            name="q2Rate"
            value="2"
            v-model.trim="form.answer_q2"
            @input="delayTouch($v.form.answer_q2)"
          />
          <label for="q2Rate2" class="form__label">2</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q2Rate3"
            type="radio"
            name="q2Rate"
            value="3"
            v-model.trim="form.answer_q2"
            @input="delayTouch($v.form.answer_q2)"
          />
          <label for="q2Rate3" class="form__label">3</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q2Rate4"
            type="radio"
            name="q2Rate"
            value="4"
            v-model.trim="form.answer_q2"
            @input="delayTouch($v.form.answer_q2)"
          />
          <label for="q2Rate4" class="form__label">4</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            class=""
            id="q2Rate5"
            type="radio"
            name="q2Rate"
            value="5 - bardzo dobrze"
            v-model.trim="form.answer_q2"
            @input="delayTouch($v.form.answer_q2)"
          />
          <label for="q2Rate5" class="form__label">5 - bardzo dobrze</label>
        </div>
      </div>
    </template>
  </FeedbackStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import FeedbackStep from '../global/FeedbackStep.vue';

export default {
  name: 'Question2',
  components: { FeedbackStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Jak ocenia Pan/Pani kontakt z Solveit (komunikacja mailowa, czas odpowiedzi na wiadomości i ich zrozumiałość)?',
    number: 2,
    form: {
      answer_q2: null,
    },
  }),
  validations: {
    form: {
      answer_q2: {
        required,
      },
    },
  },
};
</script>
